import React from "react";
import { SITE } from "@/lib/site-data";

export default function FloatingWhatsApp() {
  return (
    <a
      href={SITE.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chamar no WhatsApp"
      className="fixed bottom-5 right-5 z-40 group"
    >
      <div className="relative h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform group-hover:scale-105 pulse-ring">
        <svg viewBox="0 0 32 32" className="w-7 h-7 md:w-8 md:h-8" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.27c-.27-.13-1.59-.78-1.83-.87-.25-.09-.43-.13-.61.13-.18.27-.7.87-.86 1.05-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.54.12-.12.27-.32.4-.48.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.61-1.46-.83-2-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.35.99 2.66 1.13 2.84.13.18 1.95 2.97 4.72 4.16.66.28 1.18.45 1.58.58.66.21 1.27.18 1.74.11.53-.08 1.59-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.07-.11-.25-.18-.52-.32zM16.04 5.33c-5.84 0-10.58 4.74-10.58 10.58 0 1.86.49 3.66 1.41 5.26L5 27.33l6.32-1.65c1.55.85 3.3 1.3 5.06 1.3h.01c5.83 0 10.58-4.74 10.58-10.58 0-2.83-1.1-5.49-3.1-7.49-2-2-4.65-3.1-7.48-3.1z" />
        </svg>
      </div>
    </a>
  );
}
